import { ProtocolContentData } from "../protocol";
export class GenericProtocolContentData extends ProtocolContentData {
    record;
    constructor(record) {
        super();
        this.record = record;
    }
}
//# sourceMappingURL=GenericProtocolContentData.js.map